import { render, staticRenderFns } from "./ConfigurarLandingModalNuevo.vue?vue&type=template&id=1086174f&scoped=true&"
import script from "./ConfigurarLandingModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarLandingModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarLandingModalNuevo.vue?vue&type=style&index=0&id=1086174f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1086174f",
  null
  
)

export default component.exports